/* unplugin-vue-components disabled */import { render } from "./mobile-footer.vue?vue&type=template&id=5d55064e&scoped=true&ts=true"
import script from "./mobile-footer.vue?vue&type=script&lang=ts"
export * from "./mobile-footer.vue?vue&type=script&lang=ts"

import "./mobile-footer.vue?vue&type=style&index=0&id=5d55064e&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d55064e"]])

export default __exports__